import { Injector } from '@angular/core';
import { NotificationService } from '../../../services/notification-service/notification-service.service';

import { take } from 'rxjs';

export function markAllNotificationsAsRead(injector: Injector) {
  const notificationService = injector.get(NotificationService);
  notificationService.markAllNotificationsAsRead().pipe(take(1)).subscribe();
}
